import React, { Component, Fragment } from "react";

import { PAGES, GENERAL_CONTENT } from "../../constants/constants";
import HeaderBanner from "../../components/header-banner";
import { gaPageview } from "../../utils/dev";
export default class AboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.mapAboutVet = this.mapAboutVet.bind(this);
  }
  componentDidMount() {
    const page = PAGES["about"];
    document.title = page.title;

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    gaPageview(this.props.location);
  }

  mapAboutVet(vetAbout, dr) {
    return vetAbout.map((about, index) => {
      return <p key={`about-${dr}-${index}`}>{about}</p>;
    });
  }

  render() {
    const aboutContent = GENERAL_CONTENT["About"];
    const page = PAGES["about"];
    const aboutVetchat = aboutContent["vetchat"].map((about, index) => {
      return <p key={`about-${index}`}>{about}</p>;
    });

    // const aboutClaire = aboutContent["ourVets"][0];
    const aboutOurvets = aboutContent["ourVets"];

    const mapValues = aboutContent["ourValues"].map((value, index) => {
      return (
        <div key={`value-${index}`} style={{ marginBottom: 20 }}>
          <h4 style={{ color: "#5abdc7" }}>
            {index + 1}. {value.title}
          </h4>
          <p>{value.info}</p>
          <p className="text-italic">
            <em>Presonality: {value.personality}</em>
          </p>
          <p className="text-italic">
            <em>Pet personality: {value.petPersonality}</em>
          </p>
        </div>
      );
    });

    const mapVets = aboutOurvets.map((vet, index) => {
      return (
        <Fragment key={`vet-${index}`}>
          <div className="col-sm-4 vet-info space-small-bottom">
            <div className="image">
              <img
                src={`/images/our-vets/${vet.image}`}
                alt="vet.name"
                style={{ width: "100%" }}
              />
            </div>
            <div className="vet-title">
              <h4>{vet.name}</h4>
              <p>{vet.degree}</p>
            </div>
            <hr />
            {this.mapAboutVet(vet.about, vet.name)}
            <hr />
          </div>
          {(index + 1) % 3 === 0 && <div className="clear" />}
        </Fragment>
      );
    });

    return (
      <Fragment>
        {HeaderBanner(page.bannerTitle, page.bannerImage)}
        <div className="container">
          <div className="row page-about">
            <div className="col-sm-12">
              <h2 className="section-title">
                We’re for healthy pets and happy carers who always know what to
                do.
              </h2>
              {aboutVetchat}
            </div>
            <div className="col-sm-12 about-vets">
              <h2 className="section-title">Meet our Vets</h2>
              <div className="row">
                <div className="col-sm-12">
                  <p>
                    Vetchat’s experienced team of Veterinarians are Australian
                    board-registered and have an average experience of 11
                    yearscaring for pets. We’ve all worked in clinics as
                    neighbourhood Vets, both at home and internationally. The
                    only difference is now we’re also consulting online, because
                    we believe that’s where you need us first.
                  </p>
                </div>
                {mapVets}
              </div>
            </div>
            <div className="col-sm-12">
              <h2 className="section-title">Our Values</h2>
              {mapValues}
              <hr />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
